import * as Constants from '../Constant';

const initialState = {
    loginDetails: {},
    loginUserId: "",
    userType: "",
}

export default function loginReducer(state = initialState, action) {
    switch (action.type) {
        case Constants.LOGIN_SUCCESS:
            return {
                ...state,
                loginDetails: action.payload,
            }
        case Constants.LOGIN_USER_ID:
            return {
                ...state,
                loginUserId: action.payload,
            }
        case Constants.LOGIN_USER_TYPE:
            return {
                ...state,
                userType: action.payload,
            }
        case Constants.LOGOUT:
            return {
                ...state,
                message: {},
                loginUserId: "",
                userType: "",
            }
        default:
            return state;
    }
}